import useVehicleChargerScheduleFetcher from '@/hooks/useVehicleChargerScheduleFetcher'
import { vehicleChargersCollection } from '@/reducers/vehicleChargers'
import { scheduleToGoalsDescriptions } from '../utils/chargeScheduleUtils'
import { generateLimitsText } from '@/types/chargeSchedule/chargeSchedule.utils'
import { unenrollmentChargerDisplayName } from '../../../utils'
import { SuggestionCardProps } from '../DeviceSuggestionCard'
import { useDataAndSetLoadedState } from '../../hooks/useDataAndSetLoadedState'

export type Props = SuggestionCardProps & {
  chargerId: number
  settingsWhitelist: string[]
}

export function useLoadData(props: Props) {
  const { chargerId } = props
  const { data: chargers, isLoadingOrIdle: chargersIsLoadingOrIdle } =
    vehicleChargersCollection.useFetch()
  const { data: schedule, isLoadingOrIdle: scheduleIsLoadingOrIdle } =
    useVehicleChargerScheduleFetcher(chargerId)

  const isLoadingOrIdle = chargersIsLoadingOrIdle || scheduleIsLoadingOrIdle

  const charger = chargers?.find((charger) => charger.id === chargerId)

  return {
    isLoadingOrIdle,
    data: {
      charger,
      schedule,
    },
  }
}

export default function useViewModel(props: Props) {
  const { chargerId, setLoadedSignal, articles, settingsWhitelist } = props
  const {
    data: { charger, schedule },
    isLoadingOrIdle,
  } = useDataAndSetLoadedState({
    useLoader: useLoadData,
    props,
    setLoadedSignal,
  })

  const limitsText = generateLimitsText(schedule)
  const goalsDescriptions = scheduleToGoalsDescriptions(schedule)

  const settingPaths = {
    limits: `/devices/vehicle-charger/${chargerId}`,
    goals: `/devices/vehicle-charger/${chargerId}`,
  }

  const displayName = charger ? unenrollmentChargerDisplayName(charger) : ''

  return {
    displayName,
    isLoadingOrIdle,
    settingPaths,
    limitsText,
    goalsDescriptions,
    articles,
    settingsWhitelist,
  }
}
